<template>
  <div style="margin-top:2%; width:100%">
    <CompanyListTable />
  </div>
</template>

<script>
import CompanyListTable from "./subComponents/CompanyListTable.vue";
export default {
  name: 'companylist',
  components: { CompanyListTable },
};
</script>

<style scoped></style>
